import Dinero from 'dinero.js';
var OrderPrices = /** @class */ (function () {
    function OrderPrices() {
    }
    OrderPrices.prototype.toApi = function () {
        var _a, _b;
        return {
            isoCurrency: this.isoCurrency,
            taxesPaid: (_a = this.taxesPaid) === null || _a === void 0 ? void 0 : _a.getAmount(),
            shippingCost: (_b = this.shippingCost) === null || _b === void 0 ? void 0 : _b.getAmount()
        };
    };
    OrderPrices.createFromApi = function (dto) {
        if (!dto) {
            return null;
        }
        var taxesPaid = dto.taxesPaid ? Dinero({ amount: Math.round(dto.taxesPaid * 100), currency: "USD" }) : null;
        var shippingCost = dto.shippingCost ? Dinero({ amount: Math.round(dto.shippingCost * 10000), currency: "USD", precision: 4 }) : null;
        return Object.assign(new OrderPrices(), dto, {
            taxesPaid: taxesPaid,
            shippingCost: shippingCost
        });
    };
    return OrderPrices;
}());
export { OrderPrices };
